module.exports = __webpack_public_path__ + "img/no-user-filter.32e0ce4c.svg";